<div class="app-layout-wrapper">
  <!-- Mobile Overlay -->
  <div class="mobile-overlay" [class.active]="!isCollapsed" (click)="closeMenuOnMobile()"></div>
  <!-- Fixed Sidebar -->
  <div class="sidemenu-wrapper" [class.collapsed]="isCollapsed" [class.mobile-open]="!isCollapsed">
    <div class="sidemenu-container">
      <!-- Header Section: logo / practice name shown on mobile only (on desktop they appear in the header) -->
      <div class="sidemenu-header d-flex align-items-center">
        <div class="header-content">
          <img *ngIf="!isDesktop && logoUrl" [src]="logoUrl" alt="TRIARQ Logo" class="logo"
            (error)="onLogoError($event)" />

          <div *ngIf="!isDesktop && !logoUrl && tenantName"
            class="body2-txt-bold line-normal text-logo ion-color-gray100">{{ tenantName }}</div>
        </div>
      </div>
      <!-- Menu Items -->
      <div class="sidemenu-menu-container">
       <div class="sidemenu-menu">
         <!-- Home -->
         <div class="menu-item" [class.active]="activeMenu === 'home'" (click)="navigateTo('/home')">
          <ion-icon class="menu-icon" src="../../../assets/svg/home.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">Home</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">Home</span>
        </div>
        <!-- My Messages -->
        @if (hasAnyMessagePermission()) {
        <div class="menu-item" [class.active]="activeMenu === 'myMessages'" (click)="navigateTo('/messages')">
          <ion-icon class="menu-icon" src="../../../assets/svg/message-circle.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">My Messages</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">My Messages</span>
        </div>
        }
        <!-- Appointments -->
        @if (hasPermission('appointments')) {
        <div class="menu-item" [class.active]="activeMenu === 'appointments'" (click)="navigateTo('/appointments')">
          <ion-icon class="menu-icon" src="../../../assets/svg/calendar.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">Appointments</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">Appointments</span>
        </div>
        }

        <!-- Chart (with submenu indicator) -->
        @if (hasPermission('healthrecord') || hasPermission('phi') || hasPermission('examnotes') || hasPermission('results')) {
        <div class="menu-item has-submenu chart-menu-item" [class.expanded]="activeMenu === 'chart'"
          [class.active]="activeMenu === 'chart'">
          <div class="menu-item-main" (click)="toggleSubmenu('chart')">
            <ion-icon class="menu-icon" src="../../../assets/svg/clipboard.svg"></ion-icon>
            <span class="menu-text" *ngIf="!isCollapsed">Chart</span>

            <ion-icon 
              class="chevron-icon" 
              [src]="activeMenu === 'chart' ? '../../../assets/svg/chevron-down.svg' : '../../../assets/svg/chevron-right.svg'"
              *ngIf="!isCollapsed">
            </ion-icon>

            <span class="menu-tooltip" *ngIf="isCollapsed">Chart</span>
          </div>
        </div>
        <div class="submenu mx-10 px-14" *ngIf="activeMenu === 'chart' && !isCollapsed">
          @if (hasPermission('healthrecord')) {
          <div class="submenu-item pointer py-10 pr-14 pl-34"
            [class.active]="isActiveRoute('/health-record') && !isActiveRoute('/health-record/exam-notes') && !isActiveRoute('/health-record/results')"
            (click)="navigateTo('/health-record')">
            <ion-icon class="custom8 pr-8" src="../../../assets/svg/square-filled.svg"></ion-icon>
            <span class="submenu-text">Health Records</span>
          </div>
          }
          <!-- PE-6040: Add Exam Notes under Chart > Health Record -->
           @if (hasPermission('examnotes')) { 
          <div class="submenu-item pointer py-10 pr-14 pl-34" [class.active]="isActiveRoute('/health-record/exam-notes')"
            (click)="navigateTo('/health-record/exam-notes')">
            <ion-icon class="custom8 pr-8" src="../../../assets/svg/square-filled.svg"></ion-icon>
            <span class="submenu-text">Exam Notes</span>
          </div>
           }
          <!-- PE-6131 — Labs Results gated by results module permission -->
          @if (hasPermission('results')) {
          <div class="submenu-item pointer py-10 pr-14 pl-34" [class.active]="isActiveRoute('/health-record/results')"
            (click)="navigateTo('/health-record/results')">
            <ion-icon class="custom8 pr-8" src="../../../assets/svg/square-filled.svg"></ion-icon>
            <span class="submenu-text">Results</span>
          </div>
          }
          @if (hasPermission('phi')) {
          <div class="submenu-item pointer py-10 pr-14 pl-34"
            [class.active]="isActiveRoute('/phi/view') || isActiveRoute('/phi/submit')"
            (click)="navigateTo('/phi/view')">
            <ion-icon class="custom8 pr-8" src="../../../assets/svg/square-filled.svg"></ion-icon>
            <span class="submenu-text">PHI</span>
          </div>
          }
        </div>
        }
        <!-- Patient Forms -->
        @if (hasPermission('patientforms')) {
        <div class="menu-item" [class.active]="activeMenu === 'patientForms'" (click)="navigateTo('/patient-forms')">
          <ion-icon class="menu-icon" src="../../../assets/svg/form.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">Patient Forms</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">Patient Forms</span>
        </div>
        }
          <!-- View Statements -->
          @if (hasPermission('viewstatements')) {
          <div class="menu-item" [class.active]="activeMenu === 'statementsPayment'" (click)="navigateTo('/statements')">
            <ion-icon class="menu-icon" src="../../../assets/svg/file.svg"></ion-icon>
            <span class="menu-text" *ngIf="!isCollapsed">Statements</span>
            <span class="menu-tooltip" *ngIf="isCollapsed">Statements</span>
          </div>
          }
        <!-- My Access Log -->
        @if (hasPermission('accesslog')) {
        <div class="menu-item" [class.active]="activeMenu === 'myAccessLog'" (click)="navigateTo('/audit-log')">
          <ion-icon class="menu-icon" src="../../../assets/svg/adminForm.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">My Access Log</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">My Access Log</span>
        </div>
        }
        <!-- Restriction Request -->
        @if (hasPermission('restrictionrequest')) {
        <div class="menu-item" [class.active]="activeMenu === 'restrictionRequest'"
          (click)="navigateTo('/restriction')">
          <ion-icon class="menu-icon" src="../../../assets/svg/authorization.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">Restriction Request</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">Restriction Request</span>
        </div>
        }
        <!-- Patient Message -->
        @if (hasAssociatedPatientSelected()) {
        <div class="menu-item" [class.active]="activeMenu === 'patientMessage'" (click)="navigateTo('/patientMsg')">
          <ion-icon class="menu-icon" src="../../../assets/svg/message-circle.svg"></ion-icon>
          <span class="menu-text" *ngIf="!isCollapsed">Patient Message</span>
          <span class="menu-tooltip" *ngIf="isCollapsed">Patient Message</span>
        </div>
        }
       </div>
        <div class="sidebar-icon">
          <div class="collapse-btn pointer" (click)="toggleMenu(); $event.stopPropagation()">
            <ion-icon *ngIf="isMenuOpen" class="body1-txt mr-5" src="../../../assets/svg/sidebar-close.svg"></ion-icon>
            <span class="caption">Collapse</span>
          </div>
          <ion-icon *ngIf="!isMenuOpen" class="body1-txt desktop-menu-icon pointer"
            src="../../../assets/svg/sidebar-open.svg" (click)="toggleMenu(); $event.stopPropagation()"></ion-icon>
        </div>
      </div>
    </div>
  </div>
  <!-- Main Content Area -->
  <div class="main-content-wrapper" [class.sidebar-collapsed]="isCollapsed">
    <!-- Header -->
    <!-- Content Area -->
    <div class="content-wrapper mobile-view-header-margin">
      <ng-content></ng-content>
    </div>
  </div>
</div>